'use client';

import { ReactNode, useState } from 'react';
import { CollapsibleModuleCard } from '../../../form-builder/components/new-incorp-layout';

type WizardModuleCardProps = {
  title?: string;
  description?: string;
  badge?: string;
  defaultExpanded?: boolean;
  children: ReactNode;
};

/** A Form-Builder module card that owns its expand/collapse state (open by default). */
export const WizardModuleCard = ({
  title,
  description,
  badge,
  defaultExpanded = true,
  children,
}: WizardModuleCardProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  return (
    <CollapsibleModuleCard
      title={title}
      description={description}
      badge={badge}
      isExpanded={isExpanded}
      onExpandedChange={setIsExpanded}
      className="mt-4"
    >
      {children}
    </CollapsibleModuleCard>
  );
};
